import { render, staticRenderFns } from "./babyloan-calculator.vue?vue&type=template&id=3b4c4874&scoped=true&lang=pug"
import script from "./babyloan-calculator.vue?vue&type=script&lang=js"
export * from "./babyloan-calculator.vue?vue&type=script&lang=js"
import style0 from "./babyloan-calculator.vue?vue&type=style&index=0&id=3b4c4874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c4874",
  null
  
)

export default component.exports